<template>
  <div class="landing-page" :class="{ 'dark-mode': isDarkMode }">
    <b-container fluid class="py-4">
      <!-- Header -->
      <div class="d-flex align-items-center mb-4">
        <i class="fas fa-th-large fa-2x mr-3" style="color: #11CDEF"></i>
        <h1 class="mb-0">Applications</h1>
        <b-badge
          class="ml-3 px-3 py-2"
          style="background: rgba(17, 205, 239, 0.12); color: #11CDEF; border-radius: 30px"
        >
          {{ apps.length }} available
        </b-badge>
      </div>
      <p class="lead text-muted">Launch internal tools or external services</p>

      <!-- App Grid -->
      <b-row class="app-grid mt-4">
        <b-col
          v-for="app in apps"
          :key="app.id"
          lg="4"
          md="6"
          class="mb-4"
        >
          <b-card
            class="glass-card h-100 text-center"
            :class="{ 'dark-card': isDarkMode }"
            @click="handleAppClick(app)"
          >
            <div class="app-icon mb-4">
              <i
                v-if="app.icon"
                :class="[app.icon, 'fa-3x']"
                style="color: #11CDEF"
              ></i>
              <span
                v-else-if="app.iconSvg"
                class="svg-icon"
                v-html="app.iconSvg"
              ></span>
            </div>
            <h5 class="font-weight-bold">{{ app.name }}</h5>
            <p class="text-muted small mb-3">{{ app.description }}</p>
            <b-badge
              :variant="app.badgeVariant"
              class="app-badge"
              pill
            >
              <i :class="app.badgeIcon" class="mr-1"></i>
              {{ app.badgeText }}
            </b-badge>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LandingPage',
  data() {
    return {
      apps: [
        {
          id: 'medtracker',
          name: 'MedTracker',
          description: 'Medication schedules & compliance (Q3 2026)',
          icon: 'fas fa-pills',
          route: '/beacon-demo',
          internal: true,
          badgeText: 'Internal',
          badgeVariant: 'info',
          badgeIcon: 'fas fa-code-branch'
        },
        {
  id: 'transcribe-pairs',
  name: 'Pagers',
  description: 'Pair devices for live message',
iconSvg: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m354.03 31.622h-296.13c-31.93 0-57.9 25.97-57.9 57.9v259.5c0 12.29 13.899 19.218 23.71 12.21l82.47-58.84c6.92-4.93 15.06-7.54 23.56-7.54h181.39c31.93 0 57.9-25.97 57.9-57.9v-190.33c0-8.28-6.72-15-15-15zm-72.86 181.71h-173.31c-8.28 0-15-6.71-15-15 0-8.28 6.72-15 15-15h173.31c8.28 0 15 6.72 15 15 0 8.29-6.72 15-15 15zm0-70h-173.31c-8.28 0-15-6.71-15-15 0-8.28 6.72-15 15-15h173.31c8.28 0 15 6.72 15 15 0 8.29-6.72 15-15 15z"/><path d="m512 205.872v259.49c0 12.207-13.829 19.268-23.71 12.21l-82.47-58.83c-6.92-4.93-15.06-7.54-23.56-7.54h-181.39c-31.93 0-57.9-25.98-57.9-57.91v-28.44h168.16c48.47 0 87.9-39.43 87.9-87.9v-88.99h55.07c31.93 0 57.9 25.98 57.9 57.91z"/></g></svg>',  route: '/transcribe-pairs',
  internal: true,
  badgeText: 'Internal',
  badgeVariant: 'info',
  badgeIcon: 'fas fa-code-branch'
},
        {
          id: 'duress',
          name: 'Duress Alarm',
          description: 'Staff safety & panic system · external console',
          icon: 'fas fa-shield-alt',
          url: 'https://duress.infrafon.club/auth/login',
          internal: false,
          badgeText: 'External',
          badgeVariant: 'warning',
          badgeIcon: 'fas fa-external-link-alt'
        }
       

       
      ]
    };
  },
  computed: {
    ...mapState('darkMode', ['darkMode']),
    isDarkMode() {
      return this.darkMode;
    }
  },
  methods: {
    handleAppClick(app) {
      if (app.disabled) {
        this.$notify({
          title: 'Coming Soon',
          message: `${app.name} is not yet available.`,
          type: 'info'
        });
        return;
      }
      if (app.internal) {
        this.$router.push(app.route);
      } else {
        window.open(app.url, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.landing-page {
  min-height: 100vh;
  background: var(--bg-primary, #f8fafd);
  color: var(--text-primary, #1e293b);
  transition: background 0.2s, color 0.2s;
  padding-top: 70px;
}

/* Light Mode (Primary) */
.glass-card {
  background: #ffffff;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 28px;
  padding: 2rem 1.5rem;
  cursor: pointer;
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.3s, border-color 0.2s, background 0.2s;
}

.glass-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 36px -12px rgba(17, 205, 239, 0.25);
  border-color: #11CDEF;
}

.app-badge {
  padding: 0.5rem 1.2rem;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Dark Mode Overrides */
.landing-page.dark-mode {
  --bg-primary: #191919;
  --text-primary: #f0f0f0;
}

.dark-mode .glass-card {
  background: rgba(30, 37, 50, 0.8);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(17, 205, 239, 0.2);
  box-shadow: 0 16px 32px -8px rgba(0, 0, 0, 0.5);
  color: #f0f0f0;
}

.dark-mode .glass-card:hover {
  background: rgba(35, 45, 60, 0.9);
  border-color: #11CDEF;
}

.dark-mode .text-muted {
  color: #b0b8c5 !important;
}

/* Override Bootstrap card body padding */
.glass-card .card-body {
  padding: 0;
}

/* Match the fa-3x icons (3em ≈ 48px) so all cards line up */
.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
}

.svg-icon {
  display: inline-block;
  width: 48px;
  height: 48px;
  color: #11CDEF;
}

/* ::v-deep is required because v-html content isn't scoped */
.svg-icon ::v-deep svg {
  display: block;
  width: 100%;
  height: 100%;
  fill: currentColor;
}
</style>